import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ViewComfyAltIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"view_comfy_alt"} ref={ref}/>
});

ViewComfyAltIcon.displayName = "ViewComfyAltIcon";
